<template>
  <div>
    <AllCases
      :selectedStatuses="statuses"
      :samplesReceivedTab="true"
    ></AllCases>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);

export default {
  components: {
    AllCases,
  },
  data() {
    return {
      statuses: ["ACTIVE"],
    };
  },
};
</script>
